export default function FAQ() {
  return null;
}
